import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { NotificationService } from 'app/modules/shared/services/notification.service';

/**
 * Intercept errors from Backend
 *
 * @param req
 * @param next
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => 
{
    
    const _notificationService = inject(NotificationService);

    // Clone the request object
    let newReq = req.clone();

    // Add token and error management only for request targeting our backend
    if ( req.url.startsWith(environment.api) ) {
        // Response
        return next(newReq).pipe(
            catchError((error) => {

                    if ( error instanceof HttpErrorResponse )
                    {
                        // 400 business errors: let components handle with contextual translated messages
                        // 401/403: auth errors
                        if ( error.status === 401 || error.status === 403 )
                        {
                            _notificationService.error(error?.error?.message);
                        }
                        // 500+: generic server errors
                        else if ( error.status >= 500 )
                        {
                            _notificationService.error(error?.error?.message);
                        }
                    }
                    return throwError(error);
                })
        );
        } else {
            return next(newReq);
    }
}
